var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "directory-table" },
    [
      _c(
        "div",
        { staticClass: "tms-dashboard__panel-title-box dashboard__title" },
        [
          _c("div", { staticClass: "dashboard" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("directory.label.directory")) +
                "\n      "
            ),
            _c("i", {
              staticClass: "fa fa-refresh dark flat icon_refresh",
              attrs: { id: "dashboard_refresh" },
              on: {
                click: function () {
                  return _vm.loadDirectories()
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dashboard_button" },
            [
              _c("HKLButton", {
                staticClass: "clear-sorting",
                attrs: { color: "darkblue", action: "reset" },
                on: {
                  click: function () {
                    return _vm.resetFilter()
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("CommonTable", {
        ref: "directoriesTable",
        attrs: {
          tableContentLists: _vm.tableContent,
          renderHeaderList: _vm.headers,
          defaultOrderKey: "companyName",
          defaultOrder: true,
          interactionFunc: _vm.interactionFunc,
          tableId: _vm.tableId,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }